/**
 * Brandner Realtime Auctions
 *
 * Optimiertes Polling-System fuer Loop/Gallery-Seiten.
 * Verwendet schnelle Brandner-Endpoints statt des langsamen Plugin-Pollings.
 *
 * Features:
 * - Hash-basierte Change-Detection (keine DOM-Updates wenn unveraendert)
 * - Batch-Requests fuer mehrere Auktionen
 * - Nur auf Loop-Seiten aktiv (nicht auf Single-Product)
 */
(function($) {
    'use strict';

    var BRANDNER_DEBUG = (typeof brandnerRealtime !== 'undefined' && brandnerRealtime.debug) || false;
    function debugLog() { if (BRANDNER_DEBUG) console.log.apply(console, arguments); }
    function debugWarn() { if (BRANDNER_DEBUG) console.warn.apply(console, arguments); }

    var BrandnerRealtime = {
        pollInterval: null,
        hashCache: {},
        lastServerRemaining: {},
        serverOffset: 0,
        POLL_INTERVAL_MS: 3000,
        isPolling: false,

        // Auktionsende-Handling (Loop)
        endedHandled: {},        // pro Produkt-ID: End-Uebergang bereits ausgefuehrt?
        RESULT_LINGER_MS: 20000, // Ergebnis bleibt 20s an Ort und Stelle stehen
        FADE_MS: 800,            // Dauer des sanften Ausblendens danach
        _lastCloseTrigger: 0,    // Drosselung des Auction-Close-Triggers

        // Optimistisches Fenster pro Produkt (gesetzt von den Bid-UIs nach eigenem
        // Gebot): bis _optimisticUntil[pid] werden Server-Daten mit current_bid
        // unter _optimisticBid[pid] als stale verworfen (Cache-Race nach Gebot).
        _optimisticUntil: {},
        _optimisticBid: {},

        // Endphasen-Polling: brandner-websocket.js drosselt das Poll-Intervall
        // auf 60s sobald Pusher verbunden ist. Der End-Uebergang haengt aber an
        // Poll-Daten, wenn das auction-ended-Event spaet kommt (Close ist
        // traffic-getrieben) — in der Endphase wird deshalb wieder schnell gepollt.
        _endPhaseFast: false,
        _prevPollIntervalMs: null,

        /**
         * Initialisiert das Realtime-System.
         * Startet nur auf Loop-Seiten mit Auktions-Cards.
         */
        init: function() {
            // Guard: Doppelinitialisierung verhindern
            if (this._initialized) {
                debugLog('[BrandnerRealtime] Bereits initialisiert - Skip');
                return;
            }

            // Nur auf Loop-Seiten (NICHT Single-Product)
            if ($('body').hasClass('single-product')) {
                debugLog('[BrandnerRealtime] Single-Product-Seite - nicht aktiv');
                return;
            }

            // Mindestens eine Auktions-Card vorhanden?
            if ($('.brandner-auction-card-bid').length === 0) {
                debugLog('[BrandnerRealtime] Keine Auktions-Cards gefunden');
                return;
            }

            debugLog('[BrandnerRealtime] Initialisiert mit ' + $('.brandner-auction-card-bid').length + ' Cards');

            // Server-seitig bereits als beendet gerenderte Karten (Ergebnis-Karte mit
            // data-ended="1") sind final — nicht pollen, kein Live-Uebergang noetig.
            var self = this;
            $('.brandner-auction-card-bid[data-ended="1"]').each(function() {
                var endedId = $(this).data('product-id');
                if (endedId) self.endedHandled[endedId] = true;
            });

            // Safety: Alte Intervals aufraumen falls vorhanden
            if (this.pollInterval) clearInterval(this.pollInterval);
            if (this.clientTickInterval) clearInterval(this.clientTickInterval);

            this._initialized = true;

            // Polling starten
            this.pollInterval = setInterval(this.poll.bind(this), this.POLL_INTERVAL_MS);

            // Clientseitiges Sekunden-Tick fuer fluessige Timer-Anzeige
            this.clientTickInterval = setInterval(this.clientTick.bind(this), 1000);

            // Sofort erstes Polling
            this.poll();

            // Bei Sichtbarkeitsaenderung pausieren/fortsetzen
            this.initVisibilityHandler();
        },

        /**
         * Pausiert Polling wenn Tab nicht sichtbar.
         */
        initVisibilityHandler: function() {
            var self = this;
            document.addEventListener('visibilitychange', function() {
                if (document.hidden) {
                    if (self.pollInterval) {
                        clearInterval(self.pollInterval);
                        self.pollInterval = null;
                    }
                    if (self.clientTickInterval) {
                        clearInterval(self.clientTickInterval);
                        self.clientTickInterval = null;
                    }
                    debugLog('[BrandnerRealtime] Pausiert (Tab hidden)');
                } else {
                    if (!self.pollInterval) {
                        self.pollInterval = setInterval(self.poll.bind(self), self.POLL_INTERVAL_MS);
                        self.poll(); // Sofort aktualisieren
                    }
                    if (!self.clientTickInterval) {
                        self.clientTickInterval = setInterval(self.clientTick.bind(self), 1000);
                    }
                    debugLog('[BrandnerRealtime] Fortgesetzt (Tab visible)');
                }
            });
        },

        /**
         * Clientseitiges Sekunden-Tick: dekrementiert data-remaining jede Sekunde
         * und aktualisiert die Timer-Anzeige lokal. AJAX-Poll korrigiert server-autoritativ.
         */
        clientTick: function() {
            var clientNow = Math.floor(Date.now() / 1000);
            var offset = this.serverOffset || 0;
            var self = this;
            var anyNearEnd = false;

            $('.brandner-auction-card-bid:visible').each(function() {
                var card = $(this);
                // Beendete Lose: Timer bleibt eingefroren (00:00:00) — nicht weiter ticken.
                if (self.endedHandled[card.data('product-id')]) return;
                var endTs = parseInt(card.attr('data-end-timestamp')) || 0;

                var remaining;
                if (endTs > 0) {
                    // End-Timestamp-basierte Berechnung (kein Huepfen!)
                    remaining = Math.max(0, endTs - (clientNow + offset));
                } else {
                    // Fallback: alte Methode
                    remaining = parseInt(card.attr('data-remaining')) || 0;
                    if (remaining <= 0) return;
                    remaining--;
                    card.attr('data-remaining', remaining);
                }

                if (remaining <= 45) anyNearEnd = true;

                // Timer auf 0: Auktionsabschluss serverseitig anstossen (eliminiert Cron-Delay).
                // Gedrosselt + mit Nonce (sonst scheitert der Endpoint an check_ajax_referer).
                // Mehrfach erlaubt (Zeitfenster), damit auch gestaffelt endende Lose verarbeitet
                // werden — frueher blockierte ein Session-Lock alle weiteren Trigger.
                if (remaining <= 0) {
                    self.maybeTriggerClose();
                }

                var days = Math.floor(remaining / 86400);
                var hours = Math.floor((remaining % 86400) / 3600);
                var mins = Math.floor((remaining % 3600) / 60);
                var secs = remaining % 60;

                card.find('.timer-days').text(String(days).padStart(2, '0'));
                card.find('.timer-hours').text(String(hours).padStart(2, '0'));
                card.find('.timer-mins').text(String(mins).padStart(2, '0'));
                card.find('.timer-secs').text(String(secs).padStart(2, '0'));
            });

            // Endphase: schnelles Polling sicherstellen bzw. danach wieder entspannen
            if (anyNearEnd) {
                this.ensureFastPollingNearEnd();
            } else {
                this.relaxEndPhasePolling();
            }
        },

        /**
         * Aktiviert 1.5s-Polling, solange mindestens ein sichtbares Los kurz vor
         * dem Ende steht. Noetig, weil brandner-websocket.js das Intervall bei
         * aktiver Pusher-Verbindung auf 60s drosselt — das auction-ended-Event
         * kommt aber erst mit dem (traffic-getriebenen) formalen Close, und der
         * End-Uebergang soll nicht bis zu 60s am Health-Check-Poll haengen.
         */
        ensureFastPollingNearEnd: function() {
            if (this._endPhaseFast) return;
            if (this.POLL_INTERVAL_MS <= 3000) return; // laeuft bereits normal/schnell
            this._endPhaseFast = true;
            this._prevPollIntervalMs = this.POLL_INTERVAL_MS;
            this.POLL_INTERVAL_MS = 1500;
            if (this.pollInterval) clearInterval(this.pollInterval);
            this.pollInterval = setInterval(this.poll.bind(this), this.POLL_INTERVAL_MS);
            this.poll();
            debugLog('[BrandnerRealtime] Endphase: Polling auf 1.5s beschleunigt');
        },

        relaxEndPhasePolling: function() {
            if (!this._endPhaseFast) return;
            this._endPhaseFast = false;
            this.POLL_INTERVAL_MS = this._prevPollIntervalMs || 3000;
            if (this.pollInterval) clearInterval(this.pollInterval);
            this.pollInterval = setInterval(this.poll.bind(this), this.POLL_INTERVAL_MS);
            debugLog('[BrandnerRealtime] Endphase vorbei: Polling zurueck auf ' + this.POLL_INTERVAL_MS + 'ms');
        },

        /**
         * Sammelt sichtbare Auktions-IDs und holt aktuelle Daten.
         */
        poll: function() {
            if (this.isPolling) return;
            this.isPolling = true;

            var productIds = [];
            var self = this;

            // Nur sichtbare, noch laufende Cards abfragen.
            // Beendete Lose (endedHandled) sind eingefroren -> nicht mehr pollen (spart Payload).
            $('.brandner-auction-card-bid:visible').each(function() {
                var id = $(this).data('product-id');
                if (id && !self.endedHandled[id]) productIds.push(id);
            });

            if (productIds.length === 0) {
                this.isPolling = false;
                return;
            }

            var pollStartTime = Date.now();

            $.ajax({
                url: brandnerRealtime.ajaxUrl,
                type: 'POST',
                data: {
                    action: 'brandner_get_multiple_auctions',
                    product_ids: productIds.join(',')
                },
                dataType: 'json',
                timeout: 5000,
                success: function(response) {
                    var elapsedMs = Date.now() - pollStartTime;
                    if (response.success && response.data && response.data.auctions) {
                        self.updateCards(response.data.auctions, elapsedMs);
                    }
                },
                error: function(xhr, status, error) {
                    debugWarn('[BrandnerRealtime] Poll-Fehler:', status, error);
                },
                complete: function() {
                    self.isPolling = false;
                }
            });
        },

        /**
         * Aktualisiert alle Cards mit neuen Daten.
         * Timer wird IMMER synchronisiert, Hash-Check nur fuer Bid-Daten.
         */
        updateCards: function(auctions, elapsedMs) {
            var self = this;

            $.each(auctions, function(productId, data) {
                // Timer IMMER synchronisieren (unabhaengig vom Hash)
                self.syncTimer(productId, data, elapsedMs);

                // Auktionsende IMMER pruefen (unabhaengig vom Hash) — der Live-Uebergang
                // zu "beendet" darf nie verschluckt werden. handleCardEnded ist idempotent.
                if (data.status === 'ended') {
                    self.handleCardEnded(productId, data);
                    // Beendete Karte ist eingefroren: KEIN updateSingleCard, sonst wuerden
                    // die Live-Bietstatus-Badges das Ergebnis-Verdict wieder ueberschreiben.
                    self.hashCache[productId] = self.generateHash(data);
                    return;
                }

                // Stale-Schutz im optimistischen Fenster: direkt nach eigenem Gebot
                // koennen Polls noch alte Cache-Daten liefern (niedrigeres Gebot als
                // das gerade abgegebene) — Bid-Daten dann nicht anwenden.
                var optUntil = self._optimisticUntil[productId];
                if (data.status !== 'ended' &&
                    optUntil && Date.now() < optUntil &&
                    parseFloat(data.current_bid) < (self._optimisticBid[productId] || 0)) {
                    debugLog('[BrandnerRealtime] Stale-Daten im optimistischen Fenster verworfen: ' + productId);
                    return;
                }

                // Badges nur sicherstellen solange die Auktion laeuft

                self.ensureBadges(productId, data);

                // Hash-Check nur fuer Bid-Daten (Preis, Anzahl, Gewinner, Status)
                var newHash = self.generateHash(data);
                if (self.hashCache[productId] === newHash) {
                    return; // Keine Bid-Aenderung
                }
                self.hashCache[productId] = newHash;

                // Gebotslage geaendert -> gecachte Gebotshistorie des Karten-Popups
                // invalidieren (sonst zeigt "Gebote anklicken" fuer die ganze Session
                // den Stand des ersten Abrufs; offenes Popup laedt live nach)
                if (typeof window.brandnerInvalidateBidHistory === 'function') {
                    window.brandnerInvalidateBidHistory(productId);
                }

                self.updateSingleCard(productId, data);
            });
        },

        /**
         * Stellt sicher, dass Badges (Hoechstbietender/Ueberboten) existieren.
         * Wird bei JEDEM Poll aufgerufen (unabhaengig vom Hash), damit Badges
         * nicht durch UWA-Polling oder andere DOM-Manipulation verloren gehen.
         */
        ensureBadges: function(productId, data) {
            var currentUserId = brandnerRealtime.currentUserId || 0;
            if (currentUserId <= 0) return;

            var card = $('.brandner-auction-card-bid[data-product-id="' + productId + '"]');
            if (card.length === 0) return;

            // is_winning aus AJAX aktualisieren fuer korrekte Echtzeit-Erkennung bei Auktionsende
            if (data.status === 'ended' && data.is_winning !== undefined) {
                card.data('is-winner', data.is_winning ? 1 : 0);
                card.attr('data-is-winner', data.is_winning ? '1' : '0');
            }

            if (card.attr('data-user-has-bid') !== '1' && !data.user_has_bid) return;

            // Payload ohne Status-Feld (z.B. timer-update): Badges nicht anfassen —
            // undefined wuerde unten als "nicht fuehrend" (Ueberboten) interpretiert.
            if (data.is_winning === undefined) return;

            var liStatus = card.closest('li.product');
            if (liStatus.length === 0) return;

            var isWinning = data.is_winning;

            // Klassen auf li.product setzen (ueberlebt DOM-Manipulation)
            liStatus.toggleClass('auction-user-winning', isWinning);
            liStatus.toggleClass('auction-user-outbid', !isWinning);

            // Badge-Element sicherstellen
            var imgtext = liStatus.find('span.uwa_imgtext.bid-status-moved');
            if (imgtext.length === 0) {
                var bidCard = liStatus.find('.brandner-auction-card-bid').first();
                if (bidCard.length) {
                    imgtext = $('<span class="uwa_imgtext bid-status-moved"></span>');
                    bidCard.before(imgtext);
                }
            }
            if (imgtext.length) {
                var expectedHtml = isWinning
                    ? '<span class="uwa_winning">Höchstbietender</span>'
                    : '<span class="uwa_losing">Überboten</span>';
                if (imgtext.html() !== expectedHtml) {
                    imgtext.html(expectedHtml);
                }
                // Doppelte Badges vermeiden: statusDiv von initBidStatusColors entfernen
                liStatus.find('.auction-card-bid-status').remove();
            }
        },

        /**
         * Stoesst den serverseitigen Auktionsabschluss an (gedrosselt, mit Nonce).
         * Harmlos wenn das Los inzwischen verlaengert wurde: woo_ua_process_auction()
         * schliesst nur tatsaechlich abgelaufene Auktionen.
         */
        maybeTriggerClose: function() {
            var now = Date.now();
            if (this._lastCloseTrigger && (now - this._lastCloseTrigger) < 20000) return;
            var nonce = (typeof brandnerRealtime !== 'undefined') ? brandnerRealtime.closeNonce : '';
            if (!nonce) return; // ohne Nonce schlaegt der Endpoint fehl
            this._lastCloseTrigger = now;

            setTimeout(function() {
                jQuery.ajax({
                    url: brandnerRealtime.ajaxUrl,
                    type: 'POST',
                    data: { action: 'brandner_trigger_auction_close', nonce: nonce },
                    timeout: 10000
                });
                debugLog('[BrandnerRealtime] Auction-Close-Trigger gefeuert');
            }, 1500); // kurze Wartezeit, damit eine eventuelle Anti-Snipe-Verlaengerung landet
        },

        /**
         * Ergebnis-Verdict aus den Auktionsdaten ableiten.
         * reserve_met === false  => Mindestpreis existiert und wurde NICHT erreicht.
         * Reihenfolge wichtig: Reserve hat Vorrang vor "gewonnen".
         * 'reserve_not_met' setzt Gebote voraus — 0 Gebote sind immer 'ended'
         * (muss brandner_get_auction_end_state() in PHP entsprechen).
         */
        verdictFor: function(data) {
            var hasBids = parseFloat(data.current_bid) > 0 || parseInt(data.bid_count, 10) > 0;
            if (hasBids && (data.reserve_met === false || data.reserve_met === 0 || data.reserve_met === '0')) {
                return 'reserve_not_met';
            }
            if (data.is_winning === true) {
                return 'won';
            }
            return 'ended';
        },

        /**
         * Einheitliche Ergebnis-Texte — MUESSEN mit dem PHP-Helfer
         * brandner_auction_verdict_label() und der Produktseite uebereinstimmen.
         */
        verdictLabel: function(verdict) {
            if (verdict === 'won') return 'Zuschlag erhalten';
            if (verdict === 'reserve_not_met') return 'Mindestpreis nicht erreicht';
            return 'Los beendet';
        },

        /**
         * Live-Uebergang einer Karte in den End-Zustand (ohne Reload):
         *  - Ergebnis-Badge anzeigen, Karte ausgrauen, Bietformular sperren
         *  - dezente Ende-Animation (Gewinner: Glueckwunsch, sonst: Beendet-Flash)
         *  - nach RESULT_LINGER_MS sanft ausblenden und ans Listenende verschieben
         * Idempotent: pro Karte nur einmal.
         */
        handleCardEnded: function(productId, data) {
            if (this.endedHandled[productId]) return;

            var card = $('.brandner-auction-card-bid[data-product-id="' + productId + '"]');
            if (card.length === 0) return;
            var li = card.closest('li.product');
            if (li.length === 0) return;

            this.endedHandled[productId] = true;

            // Finaler Stand -> gecachte Gebotshistorie invalidieren
            if (typeof window.brandnerInvalidateBidHistory === 'function') {
                window.brandnerInvalidateBidHistory(productId);
            }

            // Hat der Server die Karte beim Laden bereits als beendet gerendert?
            // Dann zeigt das Template das Ergebnis schon an und PHP hat das Los bereits
            // ans Ende sortiert -> kein Live-Uebergang noetig (verhindert Doppel-Badges).
            if (card.hasClass('ended')) {
                debugLog('[BrandnerRealtime] Karte ' + productId + ' war bereits beendet (Server) - kein Live-Uebergang');
                return;
            }

            var verdict = this.verdictFor(data);

            // Karte als beendet markieren (CSS versteckt Timer/Form, Ergebnis uebernimmt)
            card.addClass('ended');
            if (verdict === 'won') card.addClass('is-winner');
            if (verdict === 'reserve_not_met') card.addClass('reserve-not-met');
            card.attr('data-ended', '1');

            // li-Klassen exakt wie beim Server-Render (UWA post_class + unser Filter):
            // - uwa_auction_status_expired: Theme graut Verlierer/Neutrale aus
            // - brandner-result-shown: unterdrueckt das BEENDET-Banner des Themes
            //   (sonst ueberlagert es Ergebnis-Badge und Gewinner-Animation)
            // - uwa-user-won: Gewinner bleibt farbig + klickbar (kein Ausgrauen)
            li.addClass('uwa_auction_status_expired brandner-result-shown');
            if (verdict === 'won') li.addClass('uwa-user-won');

            // Bietformular sperren — kein Bieten auf beendeten Losen
            card.find('.auction-card-bid-form, .auction-card-meta')
                .css('pointer-events', 'none').attr('aria-disabled', 'true');
            card.find('.bid-input, .bid-submit-btn, .bid-btn').prop('disabled', true);

            // Live-Bietstatus: "Hoechstbietender" verschwindet (das Verdict uebernimmt),
            // "Ueberboten" bleibt als persistentes Tag stehen (Konsistenz Server-Render).
            var wasOutbid = !!data.user_has_bid && !data.is_winning;
            var imgtext = li.find('span.uwa_imgtext.bid-status-moved');
            if (wasOutbid && verdict !== 'won') {
                if (imgtext.length === 0) {
                    imgtext = $('<span class="uwa_imgtext bid-status-moved"></span>');
                    card.before(imgtext);
                }
                imgtext.html('<span class="uwa_losing">Überboten</span>');
            } else {
                imgtext.remove();
            }
            li.find('.auction-card-bid-status').remove();
            this.renderCardVerdict(li, card, verdict, data);

            // Dezente Ende-Animation (eigene Dedup-Logik in BrandnerAuctionAnimations)
            if (typeof BrandnerAuctionAnimations !== 'undefined') {
                if (verdict === 'won') {
                    BrandnerAuctionAnimations.showWinnerAnimation(card, li);
                } else {
                    BrandnerAuctionAnimations.showEndedAnimation(card, li);
                }
            }

            // Sortier-/Filterdaten aktualisieren: Los gilt jetzt als beendet
            try {
                if (window.productSortData && window.productSortData[productId]) {
                    window.productSortData[productId].is_ended = true;
                }
            } catch (e) {}

            // Nach 20s: ans Listenende verschieben. Persoenliche Ergebnisse (Zuschlag
            // bzw. Mindestpreis nicht erreicht als Hoechstbietender) bleiben dabei voll
            // sichtbar — nur fremde/verlorene Lose werden gedimmt.
            this.scheduleEndedRelocate(li, productId, !!data.is_winning);

            debugLog('[BrandnerRealtime] Karte beendet: ' + productId + ' (' + verdict + ')');
        },

        /**
         * Fuegt das Ergebnis-Badge in die Karte ein (idempotent).
         */
        renderCardVerdict: function(li, card, verdict, data) {
            if (card.find('.brandner-auction-result').length) return;

            var label = this.verdictLabel(verdict);
            var icon = (verdict === 'won') ? '🏆'           // Trophaee
                     : (verdict === 'reserve_not_met') ? '🔒' // Schloss
                     : '⏱';                                       // Stoppuhr
            var priceHtml = '';
            if (verdict === 'won' && data.current_bid_formatted) {
                priceHtml = '<span class="result-price">' + data.current_bid_formatted + '</span>';
            }

            var html = '<div class="brandner-auction-result brandner-result--' + verdict + '">'
                     + '<span class="result-icon">' + icon + '</span>'
                     + '<span class="result-text">' + label + '</span>'
                     + priceHtml
                     + '</div>';

            var anchor = card.find('.auction-card-bid-form').first();
            if (anchor.length) {
                anchor.before(html);
            } else {
                card.append(html);
            }
        },

        /**
         * Plant das Ausblenden + Verschieben ans Listenende (nach RESULT_LINGER_MS).
         * keepVisible=true (eigenes Ergebnis: Zuschlag / Hoechstbietender unter
         * Mindestpreis): Los wird nur sanft verschoben, nicht auf 0.5 gedimmt —
         * das Ergebnis-Badge bleibt voll lesbar. Loest danach ein
         * 'brandner:lotreflow'-Event aus, damit Pagination/Filter neu rechnen
         * (ohne die aktuelle Seite zurueckzusetzen).
         */
        scheduleEndedRelocate: function(li, productId, keepVisible) {
            var self = this;
            setTimeout(function() {
                li.addClass(keepVisible ? 'auction-lot-fading--soft' : 'auction-lot-fading');
                setTimeout(function() {
                    var container = li.closest('ul.products');
                    if (container.length) {
                        container.append(li); // ans Ende der Liste
                    }
                    li.removeClass('auction-lot-fading auction-lot-fading--soft');
                    if (!keepVisible) {
                        li.addClass('auction-lot-faded');
                    }
                    try {
                        document.dispatchEvent(new CustomEvent('brandner:lotreflow'));
                    } catch (e) {}
                }, self.FADE_MS);
            }, self.RESULT_LINGER_MS);
        },

        /**
         * Generiert einen Hash nur aus Bid-Daten (Preis, Anzahl, Gewinner, Status).
         * Timer-Daten sind NICHT im Hash — Timer wird bei jedem Poll synchronisiert.
         * WICHTIG: status MUSS enthalten sein, sonst wird ein reiner active->ended
         * Uebergang (ohne Preisaenderung) verschluckt und die Karte bleibt "aktiv".
         */
        generateHash: function(data) {
            return [
                data.current_bid || 0,
                data.bid_count || 0,
                data.winner_id || 0,
                data.status || ''
            ].join('-');
        },

        /**
         * Synchronisiert den Timer einer Card mit dem Server-Wert.
         * Wird bei JEDEM AJAX-Poll aufgerufen (unabhaengig vom Hash).
         */
        syncTimer: function(productId, data, elapsedMs) {
            if (data.remaining === undefined) return;

            var card = $('.brandner-auction-card-bid[data-product-id="' + productId + '"]');
            if (card.length === 0) return;

            // Server-Offset kalibrieren
            if (data.server_time) {
                var clientNow = Math.floor(Date.now() / 1000);
                this.serverOffset = parseInt(data.server_time) - clientNow;
            }

            // End-Timestamp setzen
            var endTimestamp = null;
            if (data.end_timestamp) {
                endTimestamp = parseInt(data.end_timestamp);
            } else if (data.server_time && parseInt(data.remaining) > 0) {
                endTimestamp = parseInt(data.server_time) + parseInt(data.remaining);
            }

            if (endTimestamp) {
                var oldEndTs = parseInt(card.attr('data-end-timestamp')) || 0;
                card.attr('data-end-timestamp', endTimestamp);

                // Anti-Sniping: End-Timestamp verlaengert
                if (oldEndTs > 0 && endTimestamp > oldEndTs + 5) {
                    var timerElement = card.find('.auction-card-timer');
                    timerElement.addClass('timer-extended');
                    setTimeout(function() {
                        timerElement.removeClass('timer-extended');
                    }, 2500);

                    timerElement.css('position', 'relative');
                    var extendTime = brandnerRealtime.extendTimeSeconds || Math.round(endTimestamp - oldEndTs);
                    var badge = jQuery('<span class="timer-extended-badge">+' + extendTime + 's</span>');
                    timerElement.append(badge);
                    setTimeout(function() { badge.remove(); }, 2000);

                    debugLog('[BrandnerRealtime] Anti-Sniping! End-Timestamp extended: ' +
                        oldEndTs + ' -> ' + endTimestamp + ' (+' + (endTimestamp - oldEndTs) + 's)');
                }
            }

            // Fallback remaining (fuer Cards ohne End-Timestamp)
            var serverRemaining = parseInt(data.remaining) || 0;
            var elapsedSecs = (elapsedMs || 0) / 1000;
            var adjustedRemaining = Math.max(0, Math.round(serverRemaining - elapsedSecs));
            card.attr('data-remaining', adjustedRemaining);

            this.lastServerRemaining[productId] = serverRemaining;

            debugLog('[BrandnerRealtime] Timer Sync: server=' + serverRemaining +
                ', endTs=' + (endTimestamp || 'n/a') +
                ', offset=' + this.serverOffset + 's');
        },

        /**
         * Aktualisiert Bid-Daten einer einzelnen Card (Preis, Input, Status).
         * Timer-Sync passiert separat in syncTimer().
         */
        updateSingleCard: function(productId, data) {
            var card = $('.brandner-auction-card-bid[data-product-id="' + productId + '"]');
            if (card.length === 0) return;

            // Preis aktualisieren — UWA verwendet .woo-ua-auction-price im li.product
            var li = card.closest('li.product');
            if (li.length && data.current_bid_formatted) {
                var priceEl = li.find('.woo-ua-auction-price[data-auction-id="' + productId + '"]');
                if (priceEl.length) {
                    // Nur den Preis-Betrag ersetzen, "Aktuelles Gebot:" Label beibehalten
                    var amountEl = priceEl.find('.woocommerce-Price-amount');
                    if (amountEl.length) {
                        var $temp = $('<div>').html(data.current_bid_formatted);
                        var $newAmount = $temp.find('.woocommerce-Price-amount');
                        if ($newAmount.length) {
                            amountEl.replaceWith($newAmount);
                        } else {
                            amountEl.html($temp.html());
                        }
                    } else {
                        // Kein Amount-Element: Label + Preis setzen
                        priceEl.html('<span class="woo-ua-current auction">Aktuelles Gebot</span>: ' + data.current_bid_formatted);
                    }
                    priceEl.attr('data-bid', data.current_bid);
                    priceEl.addClass('updated');
                    setTimeout(function() { priceEl.removeClass('updated'); }, 600);
                }

                // Hauptpreis-Element: nur "Gebot ab" → Wrapper-Erstellung bei erstem Gebot
                var mainPriceEl = li.find('span.price').first();
                if (mainPriceEl.length && data.current_bid > 0 && !priceEl.length) {
                    // Kein Wrapper vorhanden (z.B. "Gebot ab" Text) → Wrapper erstellen
                    mainPriceEl.removeClass('auction-start-price');
                    mainPriceEl.html(
                        '<span class="woo-ua-auction-price current-bid" data-auction-id="' + productId + '" data-bid="' + data.current_bid + '" data-status="running">'
                        + '<span class="woo-ua-current auction">Aktuelles Gebot</span>: '
                        + data.current_bid_formatted
                        + '</span>'
                    );
                    mainPriceEl.addClass('updated');
                    setTimeout(function() { mainPriceEl.removeClass('updated'); }, 600);
                }
            }

            // Bid-Input aktualisieren
            if (data.next_bid) {
                var input = card.find('.bid-input');
                var newNextBid = parseFloat(data.next_bid) || 0;

                if (input.length) {
                    // Immer min-Attribut aktualisieren
                    input.attr('min', data.next_bid);

                    if (input.hasClass('user-modified')) {
                        // User hat eigenen Wert — nur zuruecksetzen wenn unter neuem Minimum
                        var userValue = parseFloat(input.data('value')) || 0;
                        if (userValue < newNextBid) {
                            input.removeClass('user-modified');
                            input.val(this.formatNumber(data.next_bid));
                            input.data('value', data.next_bid);
                            if (typeof adjustBidInputFontSize === 'function') {
                                adjustBidInputFontSize(input[0]);
                            }
                        }
                    } else {
                        // Kein User-Wert — normal aktualisieren
                        input.val(this.formatNumber(data.next_bid));
                        input.data('value', data.next_bid);
                        if (typeof adjustBidInputFontSize === 'function') {
                            adjustBidInputFontSize(input[0]);
                        }
                    }
                }
                card.attr('data-next-bid', data.next_bid);
                card.attr('data-current-bid', data.current_bid);

                // data-increment dynamisch aktualisieren
                var newIncrement = this.getIncrementForPrice(parseFloat(data.current_bid) || 0);
                card.attr('data-increment', newIncrement);

                // Dropdown-Optionen regenerieren
                this.regenerateBidOptions(card, data.next_bid);
            }

            // Gewinnerstatus aktualisieren
            // user_has_bid aus AJAX-Response aktualisieren (fuer neue Gebote nach Seitenladung)
            if (data.user_has_bid !== undefined) {
                card.attr('data-user-has-bid', data.user_has_bid ? '1' : '0');
            }

            var currentUserId = brandnerRealtime.currentUserId || 0;
            if (currentUserId > 0 && card.attr('data-user-has-bid') === '1' &&
                data.is_winning !== undefined) {
                var isWinning = data.is_winning;

                // Pulse nur bei echtem Statuswechsel (winning → outbid)
                var wasWinning = card.hasClass('bid-status-winning');

                card.toggleClass('bid-status-winning', isWinning);
                card.toggleClass('bid-status-outbid', !isWinning);

                var liStatus = card.closest('li.product');
                if (liStatus.length) {
                    liStatus.toggleClass('auction-user-winning', isWinning);
                    liStatus.toggleClass('auction-user-outbid', !isWinning);

                    // Pulse-Animation nur bei Wechsel von winning zu outbid
                    if (!isWinning && wasWinning && !liStatus.hasClass('outbid-pulse')) {
                        liStatus.addClass('outbid-pulse');
                        setTimeout(function() { liStatus.removeClass('outbid-pulse'); }, 2200);
                    }

                    // Badge aktualisieren oder erstellen (robust: .bid-status-moved Selektor)
                    var imgtext = liStatus.find('span.uwa_imgtext.bid-status-moved');
                    if (imgtext.length === 0) {
                        var bidCard = liStatus.find('.brandner-auction-card-bid').first();
                        if (bidCard.length) {
                            imgtext = $('<span class="uwa_imgtext bid-status-moved"></span>');
                            bidCard.before(imgtext);
                        }
                    }
                    if (imgtext.length) {
                        imgtext.html(isWinning
                            ? '<span class="uwa_winning">Höchstbietender</span>'
                            : '<span class="uwa_losing">Überboten</span>');
                    }

                    // Status-Div aktualisieren oder erstellen
                    var statusDiv = liStatus.find('.auction-card-bid-status');
                    if (statusDiv.length === 0) {
                        var afterEl = liStatus.find('span.uwa_imgtext.bid-status-moved');
                        var insertAfter = afterEl.length ? afterEl : liStatus.find('.woo-ua-auction-price').first();
                        if (insertAfter.length) {
                            statusDiv = $('<div class="auction-card-bid-status"></div>');
                            insertAfter.after(statusDiv);
                        }
                    }
                    if (statusDiv.length) {
                        statusDiv.removeClass('status-winning status-outbid');
                        statusDiv.addClass(isWinning ? 'status-winning' : 'status-outbid');
                        statusDiv.html(isWinning ? 'Höchstbietender' : 'Überboten');
                    }
                }
            }

            // Bid-Count aktualisieren
            if (data.bid_count !== undefined) {
                var bidCountEl = card.find('.meta-bids-count');
                if (!bidCountEl.length) bidCountEl = card.find('.timer-bids span');
                if (bidCountEl.length) {
                    bidCountEl.text(data.bid_count);
                }
            }
        },

        /**
         * Formatiert eine Zahl mit Tausendertrennzeichen (deutsch).
         */
        formatNumber: function(num) {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        },

        /**
         * Berechnet den Bietschritt fuer einen bestimmten Preis.
         * Verwendet die brandnerBidRanges aus PHP oder Default-Werte.
         */
        getIncrementForPrice: function(price, ranges) {
            ranges = ranges || window.brandnerBidRanges || (typeof brandnerRealtime !== 'undefined' && brandnerRealtime.bidRanges) || [
                {start: 0, end: 15, inc_val: 1},
                {start: 15, end: 150, inc_val: 5},
                {start: 150, end: 500, inc_val: 10},
                {start: 500, end: 1000, inc_val: 20},
                {start: 1000, end: 5000, inc_val: 50},
                {start: 5000, end: 'onwards', inc_val: 100}
            ];

            for (var i = 0; i < ranges.length; i++) {
                var range = ranges[i];
                var start = parseFloat(range.start);
                var end = (range.end === 'onwards') ? Infinity : parseFloat(range.end);
                if (price >= start && price < end) {
                    return parseFloat(range.inc_val);
                }
            }
            return 1; // Fallback
        },

        /**
         * Regeneriert die Bid-Optionen im Dropdown basierend auf dem neuen next_bid.
         * Berechnet 4 Optionen mit dynamischen Bietschritten.
         */
        /**
         * Destroy: Stop all polling and timers, reset state for re-init.
         */
        destroy: function() {
            if (this.pollInterval) {
                clearInterval(this.pollInterval);
                this.pollInterval = null;
            }
            if (this.clientTickInterval) {
                clearInterval(this.clientTickInterval);
                this.clientTickInterval = null;
            }
            this.isPolling = false;
            this._initialized = false;
            this.hashCache = {};
            this.lastServerRemaining = {};
            this._optimisticUntil = {};
            this._optimisticBid = {};
            debugLog('[BrandnerRealtime] Destroyed');
        },

        regenerateBidOptions: function(card, nextBid) {
            var dropdown = card.find('.bid-dropdown');
            if (dropdown.length === 0) return;

            nextBid = parseFloat(nextBid) || 0;
            if (nextBid <= 0) return;

            var ranges = window.brandnerBidRanges || (typeof brandnerRealtime !== 'undefined' && brandnerRealtime.bidRanges) || null;
            var self = this;

            // 4 Optionen berechnen
            var options = [];
            var value = nextBid;
            for (var i = 0; i < 4; i++) {
                options.push(value);
                var increment = this.getIncrementForPrice(value, ranges);
                value = value + increment;
            }

            // Dropdown neu befuellen
            dropdown.empty();
            options.forEach(function(opt) {
                var formatted = self.formatNumber(opt);
                dropdown.append('<div class="bid-option" data-value="' + opt + '">' + formatted + '</div>');
            });

            // data-bid-options Attribut aktualisieren
            card.attr('data-bid-options', JSON.stringify(options));

            debugLog('[BrandnerRealtime] Dropdown regeneriert fuer Produkt ' + card.data('product-id') + ': ' + JSON.stringify(options));
        }
    };

    // BrandnerRealtime global verfuegbar machen fuer externe Aufrufe
    window.BrandnerRealtime = BrandnerRealtime;

    // Initialisierung bei DOM Ready
    $(document).ready(function() {
        // Kurze Verzoegerung um sicherzustellen, dass alle anderen Skripte geladen sind
        setTimeout(function() {
            BrandnerRealtime.init();

            // UWA-Plugin-Polling auf Galerie-Seiten deaktivieren.
            // getLiveStatusAuction() ist global (uwa-front.js Z.186) und wird per
            // setInterval aufgerufen. replaceWith() darin zerstoert unsere Badges.
            // BrandnerRealtime liefert bereits alle Updates (Preis, Timer, Status).
            if (typeof window.getLiveStatusAuction === 'function' && !$('body').hasClass('single-product')) {
                window.getLiveStatusAuction = function() { return; };
                debugLog('[BrandnerRealtime] UWA-Polling deaktiviert (BrandnerRealtime uebernimmt)');
            }
        }, 500);
    });

})(jQuery);
